import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./App.scss";
import Pages from "./pages";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // Search/filter combinations can create many cached responses during a long session.
      // Release inactive entries sooner and avoid refetching every one on window focus.
      gcTime: 2 * 60 * 1000,
      staleTime: 30 * 1000,
      refetchOnWindowFocus: false,
    },
    mutations: {
      // Completed mutations are not useful to retain for React Query's five-minute default.
      gcTime: 60 * 1000,
    },
  },
});

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <ToastContainer limit={3} />
        <Pages />
      </BrowserRouter>
    </QueryClientProvider>
  );
}

export default App;
